export const getLocaleMoney = (valor) => {
    let aux = parseInt(valor)
	return aux.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}